import React from 'react';


const isJSX = function isJSX(test) {
  return test && typeof test === 'object' && React.isValidElement(test);
};

export default isJSX;
